import styled from 'styled-components';
import { StyledButton } from 'components/global/Buttons/styles/StyledComponents';

export const PanelContainer = styled.div`
  position: fixed;
  top: 20px;
  left: 20px;
  background-color: rgba(255, 255, 255, 0.8);
  border: 1px solid #ccc;
  border-radius: 5px;
  z-index: 1000;
  display: ${props => (props.isOpen ? 'block' : 'none')};
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  min-width: 600px;
`;

export const UploadContainer = styled.div`
  background-color: rgba(255, 255, 255, 0.8);
  border-radius: 5px;
  padding-left: 10px;
  padding-right: 10px;
  overflow-y: auto;
  max-height: 300px;

  direction: rtl; /* This will move the scrollbar to the left */

  & > * {
    direction: ltr; /* This will keep the content direction as left-to-right */
  }
`;

export const IconContainer = styled.div`
  position: fixed;
  top: 20px;
  left: 20px;
  z-index: 1000;
  cursor: pointer;
  opacity: 0;
  animation: fadeIn 0.5s forwards;

  @keyframes fadeIn {
    to {
      opacity: 1;
    }
  }
`;

export const CloseButton = styled.button`
  position: absolute;
  right: 10px;
  background: none;
  border: none;
  cursor: pointer;
  font-size: 16px;
`;
export const ErrorText = styled.div`
  color: red;
`;
export const StatusText = styled.div`
  color: black;
`;
export const PanelHeader = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 10px;
  padding-bottom: 10px;
  position: sticky;
  top: 0;
  background-color: rgba(255, 255, 255);
  z-index: 1;
  & h4 {
    margin: 0;
  }
`;
export const UploadItemContainer = styled.div`
  margin-bottom: 10px;
  border: 1px solid #ccc;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  gap: 5px;
  padding: 10px;
  display: flex;
  flex-direction: column;
  position: relative;
  border-radius: 5px;
`;
export const UploadItemHeader = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;
export const FileInfoContainer = styled.div`
  display: flex;
  gap: 10px;

  & p {
    margin: 0;
  }
`;
export const UploadStatusContainer = styled.div`
  color: black;
`;
export const ShowUploadsButton = styled(StyledButton)`
  background-color: ${({ theme, hasErrors }) => (hasErrors ? theme.error : '')};
  border: 1px solid ${({ theme, hasErrors }) => (hasErrors ? theme.error : '')};
  &:hover {
    background-color: ${({ theme, hasErrors }) =>
      hasErrors ? theme.maroon : ''};
    border: 1px solid
      ${({ theme, hasErrors }) => (hasErrors ? theme.maroon : '')};
  }
`;
